import { render } from "./form-quiz.vue?vue&type=template&id=30173c61&ts=true"
import script from "./form-quiz.vue?vue&type=script&lang=ts"
export * from "./form-quiz.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__